<template>
  <div class="widget-not-found">
    <div class="widget-image">
      <img src="@/assets/images/not-found.svg" />
    </div>
    <div class="widget-title">{{ title }}</div>
    <div class="widget-subtitle">
      {{ subtitle }}
    </div>
    <div class="widget-options" v-if="btn">
      <b-button @click="onClick" type="is-primary">{{ btn }}</b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "widget_select",
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    btn: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  watch: {},
  mounted() { },
  methods: {
    onClick() {
      this.$emit("click");
    },
  },
};
</script>
<style lang="scss" scoped>
.widget-not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 40px;

  .widget-image {
    width: 100px;
    height: 100px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .widget-title {
    text-align: center;
    font-size: 30px;
  }

  .widget-subtitle {
    text-align: center;
  }
}
</style>
